import mobilePhoneValidator from './phone';
import { email as emailRegex } from './regex';
import { DOMAIN_LANGUAGE } from '../constants/browser';

export const email = (value = '') =>
  !emailRegex.test((value || '').trim()) ? 'Invalid email address' : undefined;

export const required = (value) =>
  value || typeof value === 'number' ? undefined : 'Required';

export const maxLength = (max) => (value) =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;

export const mobileNumber = (country = DOMAIN_LANGUAGE) => (
  value = '',
  onlyLandline = false
) => {
  const strValue = (value || '').trim();
  const regExp = onlyLandline ? /^[\d ]+$/ : /^\+?[\d ]+$/;
  if (regExp.test(strValue)) {
    const validVal = mobilePhoneValidator(
      strValue,
      strValue.indexOf('+') !== -1 ? '' : country,
      true
    );
    if (validVal.length) {
      return undefined;
    }
  }
  return 'Invalid mobile phone number';
};
